<template>
    <!--
        TODO:
        Create a native mobile version.
        https://rituals.atlassian.net/browse/DL-19763
        https://markus.oberlehner.net/blog/accessible-custom-vue-form-select-component-simple-but-advanced/

        <select :tabindex="context.tabindex">
            <option v-for="(option, value) in context.options"
                :value="value"
                v-text="option">
            </option>
        </select>
    -->

    <div class="vue-input-select">
        <button type="button" aria-haspopup="listbox" ref="button"
            :id="`${attributes.formId}`"
            :aria-labelledby="`${attributes.formId}-label ${attributes.formId}-button`"
            :aria-expanded="shouldShowOptions"
            :class="[{'open': shouldShowOptions}, 'vue-input']"
            :disabled="attributes.disabled"
            @click.prevent="toggleOptions">
            <template v-if="selectedOptionIcon">
                <span :class="selectedOptionIcon"></span>
            </template>
            <span>{{ selectedLabel }}</span>
        </button>

        <ul v-show="shouldShowOptions" ref="options" role="listbox"
            :tabindex="context.tabindex"
            :aria-labelledby="`${attributes.formId}-label`">
            <li v-for="(option, value) in pickableOptions" role="option"
                :id="`${attributes.formId}-option-${value}`"
                :key="value"
                @click="onOptionClick(option)"
                @keypress.enter="onOptionClick(option)"
                tabindex="0">
                <template v-if="option.cssClasses">
                    <span :class="option.cssClasses"></span>
                </template>
                {{ option.label }}
            </li>
        </ul>
    </div>
</template>

<script src="./vue-input-select.js"></script>
